export const en = {
  setupProjectTitle: `Welcome! Create your first project`,
  setupProjectVisibleStepTitle: `Setup your project`,
  setupProjectHelpArticleId: '84882',
  setupProjectTitleDone: (projectName: string) => `Project: ${projectName}`,
  installBugHerdTitle: 'Get the extension',
  installBugHerdVisibleStepTitle: 'Get the extension',
  installBugHerdTitleDone: 'BugHerd installed',
  tryOnWebsiteTitle: 'Try BugHerd on your website',
  tryOnWebsiteVisibleStepTitle:
    'Now the easy part! <br />  Experience giving feedback with BugHerd.',
  tryOnWebsiteTitleDone: 'Try BugHerd on your website',
  aboutYou: `Tell us a bit about you`,
  completeOnboardingError: 'There were errors to complete onboarding.',
  editLabel: 'Edit',
  tryBugHerdDescription: 'See for yourself',
  tryBugHerdDescription2: 'how easy it is for your clients to give feedback.',
  hintMessageTryBugHerd: 'Having trouble?',
  hintDescriptionTryBugHerd: `If the BugHerd sidebar doesn't appear, try click on the BugHerd browser extension icon in your browser for further help, or try change the project URL.`,
  tryBugHerdHelpArticleId: '84858',
  visitWebsite: 'Open BugHerd on your website',
  createProject: 'Create Project',
  projectNameLabel: 'Project name',
  projectUrlLabel: 'Project URL:',
  emptyValidationMessage: 'Please complete this field',
  hintMessageProjectSetup: `What's a project?`,
  hintDescriptionProjectSetup: `A project is a website you're working on. You can have as many projects as you like, and invite different people to each one.`,
  inviteMembersPlaceholder:
    'Enter one or more email addresses, separated by commas',
  inviteMembersError: 'Errors occurred when inviting members.',
  hintMessageInviteTeam: `What’s a team member?`,
  hintDescriptionInviteTeamPara1: `In BugHerd, team members are your core team (think devs, Designers, QAs, etc). They can both give feedback & manage feedback from others.`,
  hintDescriptionInviteTeamPara2: `BugHerd also has Guest access, great for clients & stakeholders. You can find out more`,
  inviteTeamHelpArticleId: '84839',
  inviteMembers: 'Invite team members:',
  addMembers: 'Add members',
  doThisLater: 'do this later',
  moreInfo: 'More info',
  or: 'or',
  here: 'here',
  recommendedText: 'Recommended install:',
  installJsText: 'install via Javascript code',
  installJsLabel1: `Add this project's Javascript code to the`,
  installJsLabel2: ` of your website. After that, click the ‘Verify’ button.`,
  verify: `Verify`,
  verifyAgain: `Verify again`,
  verifySuccess: 'Verified successfully',
  verifySuccessMessage: 'BugHerd is installed on your website. 🎉',
  installExtMessage: `Install the Browser Extension`,
  verifyingJsMessage: 'Checking your site for the script',
  hintMessageInstallBugHerd:
    'Install the BugHerd extension to see the BugHerd sidebar on your website.',
  hintDescriptionInstallBugHerd:
    'Alternatively, you can add the Javascript code to your website’s <head> tag.',
  createGuideMessage: `What's a project?`,
  createVideoLength: '53 sec',
  createVideoKey: '83109c316627449f96a497a153e06a81',
  installGuideMessage: `Get the BugHerd extension to see the BugHerd sidebar on your website`,
  installGuideMessagePara: `Alternatively, you can add the Javascript code to your website's <head> tag.`,
  installVideoLength: '58 sec',
  installVideoKey: '992a7fe3046947cab8237b4656f2da3f',
  installHelpArticleId: '84883',
  feedbackGuideMessage: `How BugHerd works on your website`,
  feedbackGuideMessagePara: `The BugHerd sidebar will appear after your page has finished loading. After that, simply click the ‘+’ button to create feedback on your website.`,
  feedbackVideoLength: '56 sec',
  feedbackHelpArticleId: '84858',
  feedbackVideoKey: '495bf8a05106457f9be4e5490fc429f3',
  supportHref: 'mailto:support@bugherd.com',
  helpMessagePartOne: 'Need help? ',
  helpMessagePartTwo: 'Talk to us',
  personalizeExperience: 'Personalize your experience',
  personalizeExperienceTitle:
    '🎉 Nice work! Let’s personalize your BugHerd experience',
  jobRole: 'Job role:',
  industry: 'Industry:',
  companySize: 'Company size:',
  whichIntegrations:
    'Which of the following do you use? Select all that apply.',
  specifyIntegration: 'Please specify integration',
  bugherdLoad:
    'The BugHerd sidebar will appear after your page has finished loading.',
  learnToUse: (inviteMemberOnboarding: boolean) =>
    `💡 Learn to use BugHerd in ${inviteMemberOnboarding ? 4 : 3} simple steps`,
  toGetClientFeedback:
    'To get client feedback on your website, create your first project.',
  conciergeHelp1: 'Need help? We can setup your project for you.',
  conciergeHelp2: 'Get the free concierge service',
  inviteTeamDescription:
    'Invite your team members to collaborate on this project.',
  inviteTeamTitle: 'Invite your team',
  inviteTeamVisibleStepTitle: 'Invite your team',
  inviteTeamTitleDone: 'Team invited',
  inviteTeamGuideMessage: '',
  inviteTeamVideoKey: '',
  inviteTeamGuideMessagePara: '',
  inviteTeamVideoLength: '',
  bonus: 'bonus',
  bonusTitle: 'Invite your team and unlock an extra 7 days on your free trial.',
  bonusDescription: `Enter each team member's email address in the field below, separated by a comma.`,
  bonusPlaceholder: 'Enter email address(es)...',
  inviteButtonLabel: 'Invite',
  dontWantBonus: `Don't want an extra 7 days on your trial?`,
  skipButtonLabel: 'Skip',
  invalidEmailsMessage: `Some email addresses aren't formatted correctly`,
  installJavascriptCode: 'Install the BugHerd Javascript code'
};

export const Type = typeof en;
